module.exports = __webpack_public_path__ + "fc89410182adb084505238c01d7a0244.png";